import YouTubeBody from './YouTubeBody';

export default YouTubeBody;
